import postClassificationBarView from './postClassificationBarComponent.html';
import './postClassificationBarComponent.css';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ensure } from 'components/sharpr/ensure/ensure';
import _ from 'lodash';

export function postClassificationBarComponent() {
	return {
		bindings: {
			search: '=',
			classificationsLoaded: '&?',
		},
		controllerAs: 'vm',
		controller: postClassificationBarComponentCtrl,
		template: postClassificationBarView,
	};
}

export class postClassificationBarComponentCtrl {
	constructor($element, Api, $q, $scope, Taxonomy, Cfg) {
		'ngInject';
		this.classifications = [];
		this.Api = Api;
		this.Taxonomy = Taxonomy;
		this.Cfg = Cfg;
		this.$element = $element;
		this.search = ensure.object(this.search);
		this.hubs = this.search.multihub || null;
		this.loadClassifications(this.search.multihub);
		AssetManager.css('/assets/fonts/Linearicons/style.css');
		$scope.$watch('vm.search.multihub', (newVal, oldVal) => {
			if (newVal && newVal.multihub !== this.hubs) {
				// if hubs were added or removed, we need to get classifications for the new list of hubs
				this.loadClassifications(this.search.multihub);
			}
		});
	}

	loadClassifications(hubs = null) {
		const headers = hubs && hubs.length > 0 ? { Hubs: hubs } : null;
		this.Api.get('/classifications', null, headers).then(data => {
			const classifications = ensure.array(data);
			this.classifications = [];
			// deduplicate
			classifications.forEach(classification => {
				const idx = _.findIndex(this.classifications, { name: classification.name });
				if (idx === -1) {
					this.classifications.push(classification);
				}
			});
			if (this.classifications.length === 0) {
				this.$element.addClass('empty');
			}
			if (this.classificationsLoaded) {
				this.classificationsLoaded({ $classifications: this.classifications });
			}
		});
	}

	toggleClassification(classification) {
		const idx = ensure.array(this.search.classifications).indexOf(classification.name);
		if (idx >= 0) {
			// already have this one; splice it out
			this.search.classifications.splice(idx, 1);
		} else {
			// new one; add it
			if (!this.search.classifications) {
				this.search.classifications = [];
			}
			this.search.classifications.push(classification.name);
		}
	}
}
